export const TIMEFRAME_KEY = 'timeframe';

export const META_TOTAL_HEADER = 'total_header';
export const META_TIME_SCALE_KEY = 'time_scale';
